import { POSTAL_CHANNEL_DXP_ECOLABEL, POSTAL_TOPIC_ECOLABEL_SHOW } from "../constants";
import { postalPublish } from "./postalUtils";

export const triggerShowEcoLabel = (): void => {
    postalPublish({
        channel: POSTAL_CHANNEL_DXP_ECOLABEL,
        topic: POSTAL_TOPIC_ECOLABEL_SHOW,
    });
};
